import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { Grommet } from 'grommet';
import { enrichTheme } from '@enrich/shared-lib';
import { router } from './router/routes';
import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <Grommet theme={enrichTheme}>
            <RouterProvider router={router} />
        </Grommet>
    </React.StrictMode>,
);
